/**
 * FairwayBid – Anfragen-Teaser zerlegen
 *
 * Die Kacheln auf der Startseite kommen aus der Console. Jede trägt eine
 * Zeile in derselben Form:
 *
 *   **Ballwaschmaschinen** · Budget 15.000–50.000 € · Lieferung in 8 Wochen
 *
 * Als Fließtext verschenkt das seine Wirkung. Zerlegt man die Zeile, wird
 * daraus eine Karte: die Kategorie als Überschrift, die übrigen Angaben als
 * einzelne Fakten. Der Budgetrahmen ist dabei das Argument, das einen
 * Händler zum Anmelden bringt – der bekommt deshalb eine eigene Auszeichnung.
 *
 * Bewusst nachsichtig geschrieben: Wenn Tom die Zeile in der Console anders
 * schreibt, fehlt vielleicht ein Fakt, aber nichts bricht.
 *
 * Reine Zeichenkettenarbeit, kein React – damit prüfbar.
 */

const TRENNER = /\s*[·|•]\s*/;

/** Markdown-Auszeichnungen entfernen, die wir selbst setzen. */
const entferneAuszeichnung = text =>
  String(text || '')
    .replace(/\*\*/g, '')
    .replace(/^#+\s*/, '')
    .trim();

/**
 * Ist dieser Fakt eine Geldangabe? Dann wird er hervorgehoben.
 * Erkannt wird das Wort Budget ebenso wie eine Zahl mit Währung.
 */
export const istBudget = fakt => {
  const t = String(fakt || '');
  return /budget/i.test(t) || /[0-9][0-9.\s]*\s*(€|eur)/i.test(t);
};

/**
 * Zerlegt die Teaser-Zeile einer Anfrage.
 *
 * @param {string} markdown Zeile aus der Console
 * @returns {{headline: string, facts: string[], budget: string|null}}
 */
export const parseRequestTeaser = markdown => {
  const roh = String(markdown || '').trim();
  if (roh === '') {
    return { headline: '', facts: [], budget: null };
  }

  const teile = roh
    .split(TRENNER)
    .map(entferneAuszeichnung)
    .filter(t => t !== '');

  if (teile.length === 0) {
    return { headline: '', facts: [], budget: null };
  }

  const [headline, ...rest] = teile;
  const budget = rest.find(istBudget) || null;
  const facts = rest.filter(t => t !== budget);

  return { headline, facts, budget };
};
